// extracted by mini-css-extract-plugin
export default {"contact":"contact_contact__Mpx41","cards":"contact_cards__49eWH"};